<template>
  <div class="range-slider" ref="rangeSlider"></div>
</template>

<script>
  import Slider from 'nouislider/distribute/nouislider'
  import wNumb from 'wNumb/wNumb'
  import 'nouislider/distribute/nouislider.css'

  export default {
    name: 'rangeSlider',

    props: {
      taskId: {
        type: Number,
        required: true
      },
      projectId: {
        type: Number,
        required: true
      },
      value: {
        type: Number,
        required: true
      },
      etaType: {
        type: String,
        required: true
      },
      endpoint: {
        type: String
      }
    },

    data () {
      return {
        slider: null,
        baseEndpoint: 'updateTaskEta',
        maxValue: 72
      }
    },

    methods: {
      init () {
        if (this.endpoint) {
          this.baseEndpoint = this.endpoint
        }

        if (this.etaType === 'estimatedWork') {
          this.maxValue = 50
        }

        this.slider = this.$refs.rangeSlider
        Slider.create(this.slider, {
          start: this.value,
          step: 1,
          format: wNumb({
            decimals: 0
          }),
          connect: [true, false],
          range: {
            min: 0,
            max: this.maxValue
          }
        })

        this.slider.noUiSlider.on('update', (values, handle) => {
          this.$bus.$emit(`${this.baseEndpoint}Value`, this.taskId, this.projectId, Number(values[handle]), this.etaType)
        })

        this.slider.noUiSlider.on('change', () => {
          this.$bus.$emit(`${this.baseEndpoint}`, this.taskId, this.projectId, this.etaType)
        })
      }
    },

    mounted () {
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// RangeSlider.vue?4732cc3e